import PropTypes from 'prop-types';
import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import { LISTENED_BADGE_TIME_THRESHOLD, messages as m } from '../../constants/Podcasts';
import { formatTime } from '../../lib/TimeUtils';
import Badge from '../lib/Badge/Badge';

import './PodcastEpisodeMetadata.scss';

class PodcastEpisodeMetadata extends React.Component {
  static propTypes = {
    releaseDate: PropTypes.number,
    episodeDuration: PropTypes.number,
    elapsedTime: PropTypes.number,
    showSourceName: PropTypes.bool,
    showDurationOnlyAsBadge: PropTypes.bool,
    isFinished: PropTypes.bool,
  };

  getTimeLeft = () => {
    return this.props.episodeDuration - this.props.elapsedTime;
  };

  getTimeLeftBadge = () => {
    const remainingTime = this.getTimeLeft();
    const timeLeftText = (
      <FormattedMessage {...m.timeLeftBadge} values={{ timeLeft: formatTime(remainingTime) }} />
    );
    return <Badge isFilled={true} isInline={true} badgeText={timeLeftText} />;
  };

  getListenedBadge = () => {
    return (
      <Badge
        isFilled={true}
        isInline={true}
        badgeText={<FormattedMessage {...m.listenedBadge} />}
      />
    );
  };

  formatReleaseDate = () => {
    if (!this.props.releaseDate) return null;
    return (
      <FormattedDate value={this.props.releaseDate} year='numeric' month='short' day='numeric' />
    );
  };

  formatEpisodeDuration = () => {
    const { episodeDuration, elapsedTime, isFinished } = this.props;
    if (!episodeDuration) return null;

    if (isFinished) {
      return this.getListenedBadge();
    }

    if (elapsedTime) {
      const hasTimeLeft = this.getTimeLeft() > LISTENED_BADGE_TIME_THRESHOLD;
      return hasTimeLeft ? this.getTimeLeftBadge() : this.getListenedBadge();
    }

    return this.props.showDurationOnlyAsBadge ? null : <span>{formatTime(episodeDuration)}</span>;
  };

  renderMetadata = (leftText, rightText, badge = null) => {
    const metadataClass =
      this.props.showSourceName || this.props.releaseDate ? 'PodcastEpisodeMetadata' : null;
    const spacedBadge = badge && <span>&nbsp;&nbsp;{badge}</span>;
    let text = leftText;

    if (leftText && rightText) {
      text = (
        <FormattedMessage
          {...m.metadataTexts}
          values={{
            leftText,
            rightText,
          }}
        />
      );
    }

    return (
      <span className={metadataClass}>
        {text}
        {spacedBadge}
      </span>
    );
  };

  render() {
    const FormattedReleaseDate = this.formatReleaseDate();
    const FormattedEpisodeDuration = this.formatEpisodeDuration();
    const FormattedSourceName = <FormattedMessage {...m.episode} />;

    if (this.props.showSourceName && this.props.showDurationOnlyAsBadge) {
      return this.renderMetadata(
        FormattedSourceName,
        FormattedReleaseDate,
        FormattedEpisodeDuration,
      );
    }

    if (this.props.showSourceName) {
      return this.renderMetadata(FormattedSourceName, FormattedEpisodeDuration);
    }

    if (FormattedReleaseDate && FormattedEpisodeDuration) {
      return this.renderMetadata(FormattedReleaseDate, FormattedEpisodeDuration);
    }

    return FormattedReleaseDate || FormattedEpisodeDuration;
  }
}

export default PodcastEpisodeMetadata;
